import _ from 'lodash';
import { OrderedMap, fromJS, Map } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';
import { CREATE_PPSI_DONE } from '../PpsiContainer/constants';

export const createDefaultState = () =>
  fromJS({
    dishes: OrderedMap(),
    isFetching: false,
    isFetched: false,
    fetchError: null,
    isFetchingExcluded: false,
    isExcludedFetched: false,
    fetchExcludedError: null,
    isExcluding: false,
    excludeError: null,
    isIncluding: false,
    includeError: null,
    productarea: Map(),
    isProductAreaFetched: false,
    fetchProductAreaError: null,
  });

// function setupDishData(dish, isExcluded) {
//   // Normalize data
//   const ingredientEntries = dish.ingredientEntryList || [];
//   const ingredientEntryIds = ingredientEntries.map(entry => entry.id);
//   const dishNormalized = _.omit(dish, 'ingredientEntryList');
//   dishNormalized.ingredientEntryIds = ingredientEntryIds;

//   // Is Excluded
//   dishNormalized.isExcluded = isExcluded;

//   return dishNormalized;
// }
function setupDishData(dish, isExcluded) {
  // Normalize data
  const ingredientEntries = dish.ingredientEntryList || [];
  const ingredientEntryIds = ingredientEntries.map(entry => entry.id);
  // const dishNormalized = _.omit(dish, 'ingredientEntryList');
  const dishNormalized = dish;
  dishNormalized.ingredientEntryIds = ingredientEntryIds;
 
  // Is Excluded
  dishNormalized.isExcluded = isExcluded;
 
  return dishNormalized;
}
// Transform list of objects to object with the id as keys
const mergeDishes = (state, isExcluded, payload) => {
  const dishesToMerge = _.cloneDeep(_.isArray(payload) ? payload : [payload]);
  return state
    .get('dishes')
    .merge(
      dishesToMerge.reduce(
        (map, dish) =>
          map.set(dish.formulaCode, fromJS(setupDishData(dish, isExcluded))),
        OrderedMap()
      )
    );
};

function setDishesIsExcluded(state, formulaCodes = [], isExcluded) {
  let dishState = state.get('dishes');
  formulaCodes.forEach(formulaCode => {
    dishState = dishState.update(formulaCode, dish =>
      dish.set('isExcluded', isExcluded)
    );
  });
  return dishState;
}

function markDishesAsExcluded(state, formulaCodes) {
  return setDishesIsExcluded(state, formulaCodes, true);
}

function markDishesAsIncluded(state, formulaCodes) {
  return setDishesIsExcluded(state, formulaCodes, false);
}

function ppsiCreated(state, payload) {
  const { formulaCode, id } = payload;
  return state.get('dishes').update(formulaCode, dish => {
    const updatedPpsiList = dish.get('ppsiList').push(id);
    return dish.set('ppsiList', updatedPpsiList);
  });
}

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();
    case constants.FETCH_DISH:
    case constants.FETCH_DISHES:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_DISH_DONE:
      return state
        .set('dishes', mergeDishes(state, false, payload))
        .set('fetchError', null)
        .set('isFetching', false);
    case constants.FETCH_DISHES_DONE:
      return state
        .set('dishes', mergeDishes(state, false, payload))
        .set('fetchError', null)
        .set('isFetching', false);
    // .set('isFetched', true);
    case constants.FETCH_DISH_FAIL:
    case constants.FETCH_DISHES_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);
    case constants.FETCH_EXCLUDED_DISHES:
      return state
        .set('isFetchingExcluded', true)
        .set('fetchExcludedError', null);
    case constants.FETCH_EXCLUDED_DISHES_DONE:
      return state
        .set('dishes', mergeDishes(state, true, payload))
        .set('isFetchingExcluded', false)
        .set('fetchExcludedError', null);
    case constants.FETCH_EXCLUDED_DISHES_FAIL:
      return state
        .set('isFetchingExcluded', false)
        .set('fetchExcludedError', fromJS(payload));
    case constants.EXCLUDE_DISHES:
      return state
        .set('dishes', markDishesAsExcluded(state, payload))
        .set('isExcluding', true)
        .set('excludeError', null);
    case constants.EXCLUDE_DISHES_DONE:
      return state.set('isExcluding', false).set('excludeError', null);
    case constants.EXCLUDE_DISHES_FAIL:
      return state
        .set('isExcluding', false)
        .set('excludeError', fromJS(payload));
    case constants.INCLUDE_DISHES:
      return state
        .set('dishes', markDishesAsIncluded(state, payload))
        .set('isIncluding', true)
        .set('includeError', null);
    case constants.INCLUDE_DISHES_DONE:
      return state.set('isIncluding', false).set('includeError', null);
    case constants.INCLUDE_DISHES_FAIL:
      return state
        .set('isIncluding', false)
        .set('includeError', fromJS(payload));
    case CREATE_PPSI_DONE:
      return state.set('dishes', ppsiCreated(state, payload));

      case constants.GET_PRODUCT_AREA:
            return state.set('isProductAreaFetched', true).set('fetchProductAreaError', null);
          case constants.GET_PRODUCT_AREA_DONE:
            return state
              .set('productarea', fromJS(payload))
              .set('fetchProductAreaError', null)
              .set('isProductAreaFetched', false)
          case constants.GET_PRODUCT_AREA_FAIL:
            return state.set('fetchProductAreaError', fromJS(payload)).set('isProductAreaFetched', false);
    default:
      return state;
  }
}
